import React, { Component } from "react"
import format from 'format-number'
import axios from '../axios'
import { connect } from 'react-redux'
import { updateSaldo } from '../actions/saldoAction'
import Alert from 'react-s-alert'

class CardSaldo extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isLoading : true
        }
    }

    componentDidMount() {
        this.setState({ isLoading: true })

        axios.get("/saldo/getSaldo")
            .then(response => {

                const result = response.data
                
                this.props.updateSaldo(result.jumlah_saldo)

                this.setState({ isLoading: false })
            })
            .catch(error => {
                console.log(error)
                this.setState({ isLoading: false })
                Alert.error("Gagal terhubung ke server!")
            })
    }    

    render() {
        return (
            <div className="card card-inverse card-primary">
                <div className="card-block pb-0">
                    <h2 className="mb-0">{format({prefix: 'Rp ', integerSeparator: "."})(this.props.jumlah_saldo)}</h2>
                    <p style={{marginTop: "10px"}}>
                        * Saldo yang belum ditagihkan
                    </p>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    jumlah_saldo: state.saldoReducer.jumlah_saldo
})

const mapDispatchToProps = (dispatch) => ({
    updateSaldo: (jumlah_saldo) => {
        dispatch(updateSaldo(jumlah_saldo))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(CardSaldo);


// WEBPACK FOOTER //
// ./src/components/CardSaldo.js